import { render, staticRenderFns } from "./TicketFull.vue?vue&type=template&id=49ccaf34&scoped=true&"
import script from "./TicketFull.vue?vue&type=script&lang=js&"
export * from "./TicketFull.vue?vue&type=script&lang=js&"
import style0 from "./TicketFull.vue?vue&type=style&index=0&id=49ccaf34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ccaf34",
  null
  
)

export default component.exports